import React, { useRef, useEffect, useMemo } from 'react';
import { DateTime } from "luxon";
import { TeamCard } from './teamCard/teamCard';
import {
    Timeline,
    refreshPlannerTimeMarker,
    syncAllPlannerScrollViews,
    applyCurrentTimeXToScrollViews,
} from './teamCard/plannerViewTeamCard';
import { Container } from '../general_components/content_management/list_view/listView';
import { ListViewHeader } from '../general_components/content_management/list_view/listViewHeader';
import styles from './mainBoardSettings.module.scss';
import plannerViewstyles from './teamCard/plannerView.module.scss';
import { CustomLoadingIcon } from '../supplementary_components/loading_icon';
import { useBoardStore } from './boardStore';
import { msUntilNextServerMinute } from './serverClock';
import { addNotification } from '../supplementary_components/store';


export const TeamContentWrapper = ({teamsList, boardConf, currentTime, plannerMode, popupViewManagingObject, currentCompanyId, mainlySolo, userCanSeeLoadRates}) => {
    const uiBusRef = useRef(null);
    if (!uiBusRef.current) {
        uiBusRef.current = { scrollableViews: {} };
    }
    const uiBus = uiBusRef.current;
    return plannerMode ? <PlannerMode teamsList={teamsList} boardConf={boardConf} trucksSetDataMethodsObject={uiBus} currentTime={currentTime} popupViewManagingObject={popupViewManagingObject} currentCompanyId={currentCompanyId}  mainlySolo={mainlySolo} userCanSeeLoadRates={userCanSeeLoadRates} /> : <ReugalMode teamsList={teamsList} boardConf={boardConf} trucksSetDataMethodsObject={uiBus} currentTime={currentTime} popupViewManagingObject={popupViewManagingObject} currentCompanyId={currentCompanyId} mainlySolo={mainlySolo} />
}
const ReugalMode = ({teamsList, boardConf, trucksSetDataMethodsObject, currentTime, popupViewManagingObject, currentCompanyId, mainlySolo}) => {
    const currentTimeRef = useRef(null);

    useEffect(() => {
        const syncFromServerClock = () => {
            const live = useBoardStore.getState().getLiveCurrentTime?.();
            if (live) {
                currentTimeRef.current = live;
            } else if (currentTime) {
                currentTimeRef.current = DateTime.fromISO(currentTime, { setZone: true });
            }
        };
        syncFromServerClock();
        trucksSetDataMethodsObject.currentTimeRef = currentTimeRef;

        const delay = msUntilNextServerMinute(useBoardStore.getState().timeAnchor);
        let intervalId;
        const timeoutId = setTimeout(() => {
            syncFromServerClock();
            intervalId = setInterval(syncFromServerClock, 60_000);
        }, delay);

        return () => {
            window.clearTimeout(timeoutId);
            window.clearInterval(intervalId);
        };
    }, [currentTime, trucksSetDataMethodsObject]);

    return <>
        <div className={styles.mainBoardHeader}>
            <Container
            // style={{ ['--list-columns']: boardConf.columnProportions }}
                $customcss={
                    `
                        min-width: 100%;
                    `
                    } 
                >
                <ListViewHeader LabelConf={boardConf} OrderedByLabelIndex={3} customFontSize="0.9rem" columnProportions={boardConf.headerColumnProportions} />
            </Container>
            
        </div>
        {
            teamsList.map((team, index) => {
                return <TeamCard key={index} index={index} mainBoardConf={boardConf} teamData={team} trucksSetDataMethodsObject={trucksSetDataMethodsObject} popupViewManagingObject={popupViewManagingObject} plannerMode={false} currentTime={currentTime} currentCompanyId={currentCompanyId} mainlySolo={mainlySolo} />
            })
        }
    </>
    
    
}
const PlannerMode = ({teamsList, boardConf, trucksSetDataMethodsObject, currentTime, popupViewManagingObject, currentCompanyId, mainlySolo, userCanSeeLoadRates}) => {
    const overflowContainer = useRef(null);
    const currentTimeRef = useRef(null);

    // Seed once from server; live ticks advance via timeAnchor (not DateTime.now()).
    // Re-seed only when the snapshot currentTime string changes (rehydrate).
    useEffect(() => {
        const live = useBoardStore.getState().getLiveCurrentTime?.();
        if (live) {
            currentTimeRef.current = live;
        } else if (currentTime) {
            currentTimeRef.current = DateTime.fromISO(currentTime, { setZone: true });
        }
    }, [currentTime]);

    if (!currentTimeRef.current && currentTime) {
        currentTimeRef.current = DateTime.fromISO(currentTime, { setZone: true });
    }
    trucksSetDataMethodsObject.currentTimeRef = currentTimeRef;
    if (!trucksSetDataMethodsObject.scrollableViews) {
        trucksSetDataMethodsObject.scrollableViews = {};
    }
    const beggingingOfDyMl = useMemo(() => {
        const seed = currentTime
            ? DateTime.fromISO(currentTime, { setZone: true })
            : currentTimeRef.current;
        return seed ? seed.startOf('day').toMillis() : 0;
    }, [currentTime]);
    const filterText = useBoardStore(s => s.filterText);

    const trucksContainerRef = useRef(null);
    useEffect(() => {
        let intervalId;
        const delay = msUntilNextServerMinute(useBoardStore.getState().timeAnchor);
        const timeoutId = setTimeout(() => {
            refreshPlannerTimeMarker(currentTimeRef, beggingingOfDyMl, trucksSetDataMethodsObject);
            intervalId = setInterval(() => {
                refreshPlannerTimeMarker(currentTimeRef, beggingingOfDyMl, trucksSetDataMethodsObject);
            }, 60000);
        }, delay);
        const root = trucksContainerRef.current;
        let activeTruckNumber = null;
        const setHighlight = (truckNumber) => {
            if (activeTruckNumber && activeTruckNumber !== truckNumber) {
                
                root.querySelector(`[data-hglht="${activeTruckNumber}"]`)?.classList.remove("highlight");
            }
            activeTruckNumber = truckNumber || null;
            if (activeTruckNumber) {
                root.querySelector(`[data-hglht="${activeTruckNumber}"]`)?.classList.add("highlight");
            }
        };
        const handleOver = (e) => {
            const trigger = e.target.closest("[data-trigger]");
            if (!trigger || !root.contains(trigger)) return;
            setHighlight(trigger.getAttribute("data-target-id"));
        };
        const handleOut = (e) => {
            // If moving to another trigger inside the same container, let handleOver handle it
            const nextTrigger = e.relatedTarget?.closest?.("[data-trigger]");
            if (nextTrigger && root.contains(nextTrigger)) return;
            setHighlight(null);
        };
        if(root){
            root.addEventListener("mouseover", handleOver);
            root.addEventListener("mouseout", handleOut);
        }
        return () => {
            window.clearInterval(intervalId);
            window.clearTimeout(timeoutId);
            if(root){
                root.removeEventListener("mouseover", handleOver);
                root.removeEventListener("mouseout", handleOut);
                if (activeTruckNumber) {
                    root.querySelector(`[data-target="${activeTruckNumber}"]`)?.classList.remove("highlight");
                  }
            }
        }
        // eslint-disable-next-line
    }, [currentTime, beggingingOfDyMl]);

    useEffect(() => {
        const timeoutId = setTimeout(() => {
            syncAllPlannerScrollViews(trucksSetDataMethodsObject);
            if (trucksSetDataMethodsObject.currentTimeMarkerX != null) {
                applyCurrentTimeXToScrollViews(trucksSetDataMethodsObject, trucksSetDataMethodsObject.currentTimeMarkerX);
            }
        }, 0);
        return () => clearTimeout(timeoutId);
    }, [filterText, trucksSetDataMethodsObject]);

    useEffect(() => {
        const popup = overflowContainer.current;
        if (!popup) return;
        const handleCoordsCopy = (e) => {
            const target = e.target?.closest?.('[data-latlng]');
            if (!target || !popup.contains(target)) return;
            const latLng = target.getAttribute('data-latlng');
            if (!latLng) return;
            e.stopPropagation();
            navigator.clipboard.writeText(latLng).then(() => {
                addNotification({ message: 'Coordinates copied', type: 'success' });
            }).catch(() => {
                addNotification({ message: 'Failed to copy coordinates', type: 'alert' });
            });
        };
        popup.addEventListener('click', handleCoordsCopy);
        return () => popup.removeEventListener('click', handleCoordsCopy);
    }, []);

    const handleScroll = (e)=>{
        const horizontalScrollTimeline = useBoardStore.getState().horizontalScrollTimeline !== false;
        // When timeline horizontal scroll is off: only Shift+wheel remaps to horizontal.
        if (!horizontalScrollTimeline && !e.shiftKey) {
            return;
        }
        e.preventDefault();
        let popupDelta = 0;
        const delta = e.shiftKey && e.deltaX === 0 ? e.deltaY : (e.deltaX !== 0 ? e.deltaX : e.deltaY);
        for(const key of Object.keys(trucksSetDataMethodsObject.scrollableViews)){
            const target = trucksSetDataMethodsObject.scrollableViews[key];
            let scrolled = target.scrollLeft;
            target.scrollLeft += delta;
            scrolled -= target.scrollLeft;

            if(popupDelta === 0 && scrolled !== 0){
                popupDelta = scrolled;
            }
        }

        const views = Object.values(trucksSetDataMethodsObject.scrollableViews || {});
        if (views.length > 0) {
            trucksSetDataMethodsObject.sharedScrollLeft = views[0].scrollLeft;
        }

        if(popupDelta !== 0 && overflowContainer && overflowContainer.current && overflowContainer.current.style.display !== "" ){
            const popup = overflowContainer.current;
            // Move popup horizontally together with the timeline, regardless of whether it was
            // positioned using `left` or `right`.
            if(popup.style.left !== ""){
                const currentLeft = parseFloat(popup.style.left || '0');
                popup.style.left = `${currentLeft + popupDelta}px`;
            }else if(popup.style.right !== ""){
                // If the popup is anchored from the right, moving it "with content"
                // requires changing `right` in the opposite direction.
                const currentRight = parseFloat(popup.style.right || '0');
                popup.style.right = `${currentRight - popupDelta}px`;
            }else{
                // Fallback: treat as left-anchored
                const currentLeft = parseFloat(popup.style.left || '0');
                popup.style.left = `${currentLeft + popupDelta}px`;
            }
        }
    }
    return <>
        <div className={styles.mainBoardHeader}>
            <Container
                $customcss={
                    `
                        // padding-right:1rem;
                        // padding-top:1rem;
                        border-right: solid thin var(--lighter-gray);
                        // box-shadow: 8px 0 14px -10px rgba(15, 23, 42, 0.45);
                        z-index: 2;
                        max-width:${boardConf.headerSectionWidthRem != null ? boardConf.headerSectionWidthRem : 51.5}rem;
                        min-width:${boardConf.headerSectionWidthRem != null ? boardConf.headerSectionWidthRem : 51.5}rem;
                    `
                    } 
                >
                    <ListViewHeader
                        LabelConf={boardConf}
                        OrderedByLabelIndex={3}
                        customFontSize="0.9rem"
                        columnProportions={boardConf.headerColumnProportions}
                        customHeight="3rem"
                        columnGap={boardConf.headerColumnGap}
                        compactPadding={boardConf.headerCompactPadding}
                        headerPaddingLeftRem={boardConf.headerPaddingLeftRem}
                    />
            </Container>
            <Container
                $customcss={`
                    min-width: 0;
                    width: auto;
                    overflow: hidden;
                `}
            >
                <Timeline currentTime={currentTime} trucksSetDataMethodsObject={trucksSetDataMethodsObject} handleScroll={handleScroll} currentTimeRef={currentTimeRef}  beggingingOfDyMl={beggingingOfDyMl} />
            </Container>
        </div>
        <div ref={trucksContainerRef}>{
            teamsList.map((team, index) => {
                // return null;
                return <TeamCard  key={index} index={index} mainBoardConf={boardConf} teamData={team} trucksSetDataMethodsObject={trucksSetDataMethodsObject} popupViewManagingObject={popupViewManagingObject} plannerMode={true} currentTime={currentTime} 
                    handleScroll={handleScroll}
                    currentTimeRef={currentTimeRef}
                    beggingingOfDyMl={beggingingOfDyMl}
                    overflowContainer={overflowContainer}
                    currentCompanyId={currentCompanyId}
                    mainlySolo={mainlySolo}
                />
            })
            
        }
        <div ref={overflowContainer} className={plannerViewstyles.overflowingViewModal}>
            <span className={"loadView"} style={{display:"block"}}>
                <table>
                    <tbody>
                        <tr ><td className={plannerViewstyles.lbl}>Load:</td><td className={`${plannerViewstyles.loadNumber} ${plannerViewstyles.underline}`} id="loadNumber"></td></tr>
                        <tr className={userCanSeeLoadRates ? undefined : plannerViewstyles.hasBottomLine}><td className={plannerViewstyles.lbl}>Current Status:</td><td className={plannerViewstyles.specialValue}><span id="currentStatus"></span></td></tr>
                        {userCanSeeLoadRates ? <tr className={plannerViewstyles.hasBottomLine}><td className={plannerViewstyles.lbl}>Rate:</td><td className={plannerViewstyles.loadNumber} id="loadRate"></td></tr> : null}
                        <tr><td></td></tr> 
                        <tr className={plannerViewstyles.hasBottomLine} id="warningBlock">
                            <td className={`${plannerViewstyles.addressLbl} ${plannerViewstyles.lbl}`}>Alerts:</td>
                            <td className={`${plannerViewstyles.warningDesc} ${plannerViewstyles.desc}`} id="warningBlockContent"></td>
                        </tr>
                        {/* <tr className={plannerViewstyles.hasBottomLine} id="etaBlock">
                            <td className={`${plannerViewstyles.addressLbl} ${plannerViewstyles.lbl}`}>ETA:</td>
                            <td className={`${plannerViewstyles.etaDesc} ${plannerViewstyles.desc}`} id="etaBlockContent"></td>
                        </tr> */}
                        <tr id="warningBlockBottom"><td></td></tr>  
                        
                        <tr className={plannerViewstyles.noPadding}><td className={plannerViewstyles.lbl}>Origin:</td><td id="firstPUDateTime" className={plannerViewstyles.vals}></td></tr>
                        <tr  style={{display:"none"}} className={`${plannerViewstyles.noPadding} ${plannerViewstyles.hasNoTopPadding}`}>
                            <td></td>
                            <td id="firstStopETAHolder" className={plannerViewstyles.ETAHolder}><span className="etaLabel"></span><div className={plannerViewstyles.etaSpinner}><CustomLoadingIcon height="0.8rem" /></div></td>
                        </tr>
                        <tr className={`${plannerViewstyles.originCityState}`}><td></td><td id="firstPUCityState" className={plannerViewstyles.val}></td></tr>
                        

                        <tr style={{display:"none"}} className={`${plannerViewstyles.noPadding} ${plannerViewstyles.inbetweenStopFirstLine}`}>
                            <td id="inbetweenStopNumberHolder" className={plannerViewstyles.lbl}>Stop #2:</td><td id="inbetweenStopTimeHolder" className={plannerViewstyles.vals}></td>
                        </tr>
                        <tr style={{display:"none"}}  className={`${plannerViewstyles.noPadding} ${plannerViewstyles.hasNoTopPadding} `}>
                            <td></td>
                            <td id="inbetweenStopETAHolder" className={plannerViewstyles.ETAHolder}><span className="etaLabel"></span><div className={plannerViewstyles.etaSpinner}><CustomLoadingIcon height="0.8rem" /></div></td>
                        </tr>
                        <tr style={{display:"none"}} className={`${plannerViewstyles.inbetweenStopSecondLine} ${plannerViewstyles.hasNoTopPadding}`}>
                            <td></td>
                            <td id="inbetweenStopPUCityState" className={plannerViewstyles.val}></td>
                        </tr>

                        <tr className={`${plannerViewstyles.destinationTime}`}><td className={plannerViewstyles.lbl}>Destination:</td><td id="lastDELDateTime" className={plannerViewstyles.vals}></td></tr>
                        <tr  style={{display:"none"}} className={`${plannerViewstyles.noPadding} ${plannerViewstyles.hasNoTopPadding}`}>
                            <td></td>
                            <td id="lastStopETAHolder" className={plannerViewstyles.ETAHolder}><span className="etaLabel"></span><div className={plannerViewstyles.etaSpinner}><CustomLoadingIcon height="0.8rem" /></div></td>
                        </tr>
                        <tr className={plannerViewstyles.hasNoTopPadding}><td></td><td id="lastDELCityState" className={plannerViewstyles.val}></td></tr>
                    </tbody>
                    
                </table>
                
                <div id="statusChangeButton" className={plannerViewstyles.statusChangeButton}>
                    <span>Mark As Arrived</span> <CustomLoadingIcon height="1rem" customStrokeWidth="0.5rem" />
                </div>
            </span>
            <span className={"taskView"}  style={{display:"none"}}> 
                <table>
                    <tbody>
                        <tr id="addressBlock">
                            <td className={plannerViewstyles.addressLbl}>Address:</td>
                            <td className={plannerViewstyles.val}></td>
                        </tr>
                        <tr id="timeBlock">
                            <td className={plannerViewstyles.lbl}>Date/Time:</td>
                            <td className={plannerViewstyles.val} id="taskDatetime"></td>
                        </tr>
                    </tbody>
                </table>
                <div className={plannerViewstyles.taskBlock} >
                    <div className={`tskLbl ${plannerViewstyles.taskLabel} ${plannerViewstyles.val}`} ></div>
                    <div className={`tskDsc ${plannerViewstyles.vals}`} ></div>
                    <div className={`${plannerViewstyles.statusChangeButton} btn`}>
                        <span>Mark As Dispatched</span> <CustomLoadingIcon height="1rem" customStrokeWidth="0.5rem" />
                    </div>
                </div>
            </span>
        </div>
        </div>
    </>
    
    
    
}

